<template>
  <Teleport to="body">
    <div v-if="plan" class="plan-details-backdrop" @click.self="$emit('close')" @keydown.esc="$emit('close')">
      <section ref="dialog" class="plan-details-dialog" role="dialog" aria-modal="true" aria-labelledby="plan-details-title" tabindex="-1" @keydown.tab="trapFocus">
        <button type="button" class="plan-details-close" aria-label="Fechar detalhes do plano" @click="$emit('close')">×</button>
        <p class="text-success fw-semibold">7 dias grátis, sem cartão</p>
        <h2 id="plan-details-title">{{ plan.name }}</h2>
        <p>{{ plan.description }}</p>
        <p class="plan-details-price">{{ price }}<small> /mês após o período gratuito</small></p>
        <ul v-if="plan.features?.length"><li v-for="feature in plan.features" :key="feature">{{ feature }}</li></ul>
        <p v-if="plan.max_users != null">Até {{ plan.max_users }} profissionais.</p>
        <p v-if="plan.max_services != null">Até {{ plan.max_services }} serviços.</p>
        <button ref="closeButton" type="button" class="btn btn-success w-100" @click="$emit('close')">Entendi</button>
      </section>
    </div>
  </Teleport>
</template>

<script>
export default {
  props: { plan: { type: Object, default: null } },
  emits: ['close'],
  data: () => ({ previousFocus: null, previousOverflow: '' }),
  computed: { price() { return Number(this.plan?.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); } },
  watch: {
    plan: {
      async handler(value) {
        if (value) {
          this.previousFocus = document.activeElement;
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          await this.$nextTick();
          this.$refs.closeButton?.focus();
        } else this.restoreFocus();
      },
    },
  },
  beforeUnmount() { if (this.plan) this.restoreFocus(); },
  methods: {
    restoreFocus() { document.body.style.overflow = this.previousOverflow; this.previousFocus?.focus(); },
    trapFocus(event) {
      const buttons = this.$refs.dialog.querySelectorAll('button');
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    },
  },
};
</script>

<style scoped>
.plan-details-backdrop { position: fixed; inset: 0; z-index: 11000; background: #152c3580; display: flex; align-items: center; justify-content: center; padding: 16px; }
.plan-details-dialog { position: relative; width: 100%; max-width: 520px; max-height: calc(100dvh - 32px); overflow-y: auto; background: white; color: #24363d; padding: 32px 24px; border-radius: 20px; box-shadow: 0 24px 80px #0003; overflow-wrap: anywhere; }
.plan-details-dialog h2 { padding-right: 24px; font-size: 24px; }
.plan-details-dialog li { margin-bottom: 10px; }
.plan-details-close { position: absolute; right: 12px; top: 8px; background: transparent; border: 0; font-size: 30px; width: 44px; height: 44px; }
.plan-details-price { font-size: 24px; font-weight: 700; }
.plan-details-price small { display: block; font-size: 13px; font-weight: 400; }
</style>
